// extracted by mini-css-extract-plugin
export var container = "StateDescription-module--container--mOscB";
export var stateDescription = "StateDescription-module--stateDescription--Pzm91";